import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export interface SelectOption {
    value: string;
    label: string;
}

@Component({
    selector: 'lokos-select',
    templateUrl: './select.component.html',
    styleUrl: './select.component.scss',
    standalone: false,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SelectComponent),
            multi: true,
        },
    ],
})
export class SelectComponent implements ControlValueAccessor {
    @Input() label = '';
    @Input() placeholder = 'select';
    @Input() options: SelectOption[] = [];
    @Input() disabled = false;

    @Output() valueChange = new EventEmitter<string>();

    value = '';
    private onChange: (value: string) => void = () => undefined;
    private onTouched: () => void = () => undefined;

    writeValue(value: string): void {
        this.value = value || '';
    }

    registerOnChange(fn: (value: string) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    onSelectChange(event: Event) {
        const target = event.target as HTMLSelectElement;
        this.value = target.value;
        this.onChange(this.value);
        this.valueChange.emit(this.value);
    }
}
